



















import { Vue, Component } from 'vue-property-decorator';
import AdminNavbar from '@/components/admin/AdminNavbar.vue';
import brandModule from '../../store/modules/brand.module';
import errorModule from '../../store/modules/error.module';
import { BRAND_LOGIN_PAGE } from '../../common/routes.config';

@Component({
  components: {
    AdminNavbar,
  },
})
export default class AdminRoot extends Vue {
  loadingRequest = false;

  async created(): Promise<void> {
    if (!this.$router.currentRoute.params.brandId) { return; }
    await brandModule.fetchBrand(this.$router.currentRoute.params.brandId);
    if (errorModule.hasError) {
      errorModule.clearError();
      this.$router.push(BRAND_LOGIN_PAGE);
      this.loadingRequest = false;
    }
  }
}
